import type { Apunte } from '../api/accounting';

/** Lo que cuesta (o lo que se ingresa) de verdad: base + IVA. En una factura
 *  con retención de IRPF el total es menor, pero la retención también se paga
 *  (a Hacienda, en el Modelo 111), así que el libro suma el total más la
 *  retención. Sin retención es exactamente el total, como siempre.
 *
 *  Vive aquí y no en api/accounting.ts para que el export CSV no cargue el
 *  cliente de la API. */
export const importeApunte = (a: Apunte) => (a.total ?? 0) + (a.irpf_amount ?? 0);
